export default "__VITE_ASSET__54Smyr3J__"